<template>
  <layout :title="pageTitle">
    <section class="content mt-5">
      <b-table v-if="downloads.length > 0" :data="downloads">
        <b-table-column field="Name" label="Name" v-slot="props">
          <a
            v-if="props.row.status_name == 'Completed'"
            :href="route('downloads.show', props.row.unique_id)"
            :download="props.row.name"
            >{{ props.row.name }}</a
          >
          <span v-else>{{ props.row.name }}</span>
        </b-table-column>

        <b-table-column field="type" label="Type" v-slot="props">
          {{ props.row.type_name }}
        </b-table-column>

        <b-table-column
          field="generated_by"
          label="Generated By"
          v-slot="props"
        >
          <inertia-link
            :href="route('users.show', props.row.owner.unique_id)"
            >{{ props.row.owner.name }}</inertia-link
          >
        </b-table-column>

        <b-table-column field="type" label="Date" v-slot="props">
          <b-tooltip
            position="is-left"
            :label="datetime(props.row.created_at)"
            type="is-success"
          >
            <span class="tag is-success">
              {{ dateFromNow(props.row.created_at) }}
            </span>
          </b-tooltip>
        </b-table-column>

        <b-table-column field="status" label="Status" v-slot="props">
          {{ props.row.status_name }}
        </b-table-column>

        <b-table-column label="Actions" v-slot="props">
          <span class="is-flex" v-if="props.row.status_name == 'Completed'">
            <div
              class="icon-container is-clickable ml-1 mr-2"
              @click="deleteDownload(props.row)"
            >
              <b-icon
                pack="fas"
                icon="trash"
                type="is-danger"
                size="is-small"
              ></b-icon>
            </div>
            <a
              :href="route('downloads.show', props.row.unique_id)"
              :download="props.row.name"
            >
              <b-icon
                pack="fas"
                icon="download"
                type="is-success"
                size="is-small"
                class="ml-2"
              ></b-icon>
            </a>
          </span>
        </b-table-column>
      </b-table>
      <p v-else><i>There are no downloads</i></p>
    </section>
  </layout>
</template>

<script>
import Layout from './Layout';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default {
  components: {
    Layout,
  },
  props: {
    downloads: { type: Array },
    errors: { type: Object },
    flash: { type: Object },
  },
  data() {
    return {
      pageTitle: 'Downloads',
    };
  },
  mounted() {
    if (this.flash.success) {
      this.$buefy.snackbar.open({
        message: this.flash.success,
        type: 'is-success',
        position: 'is-top',
        duration: 10000,
      });
    }
  },
  methods: {
    dateFromNow(date) {
      return dayjs(date).fromNow();
    },
    datetime(date) {
      return (
        dayjs(date).format('YYYY-MM-DD, H:mm:ss') ?? 'Error: Date not found'
      );
    },
    deleteDownload(download) {
      this.$inertia.delete(route('downloads.destroy', download.unique_id), {
        onFinish: () => {
          if (Object.keys(this.errors).length) {
            this.$buefy.toast.open({
              message: this.errors[0],
              type: 'is-danger',
              position: 'is-top',
            });
          } else if (this.flash.success) {
            this.$buefy.toast.open({
              message: this.flash.success,
              type: 'is-success',
              position: 'is-top',
            });
          }
        },
      });
    },
  },
};
</script>
